export default __webpack_public_path__ + "static/media/Feather.c54293ac.jpg";